import { ActionBar, ChakraFlex, FAIconName } from '@equip.health/ui';

const TOP_LEVEL_ID = 'group-class-confirmation';
export enum ConfirmationType {
  CREATED = 'created',
  UPDATED = 'updated',
}

type GroupClassConfirmationProps = {
  closeAccordion: () => void;
  confirmationType?: ConfirmationType.CREATED | ConfirmationType.UPDATED;
  onSuccess?: () => void;
};

const GroupClassConfirmation = ({
  closeAccordion,
  confirmationType = ConfirmationType.CREATED,
  onSuccess,
}: GroupClassConfirmationProps) => {
  const actionButtonClick = () => {
    closeAccordion();
    onSuccess?.();
  };

  return (
    <ChakraFlex justifyContent="center" padding="20px 30px">
      <ActionBar
        barIcon={FAIconName.checkRegular}
        buttonIcon={FAIconName.externalLinkRegular}
        buttonText="View group"
        id={TOP_LEVEL_ID}
        onButtonClick={actionButtonClick}
        size="medium"
        text={
          confirmationType === ConfirmationType.CREATED
            ? 'Group created'
            : 'Group updated'
        }
        variant="primary"
      />
    </ChakraFlex>
  );
};

export default GroupClassConfirmation;
